import { useMemo, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";

interface UseRenameModalReturn {
  newName: string;
  openRenameModal: (defaultName: string, onConfirm: (newName: string) => void) => void;
  RenameModal: JSX.Element;
}

const useRenameModal = (): UseRenameModalReturn => {
  const [open, setOpen] = useState(false);
  const [newName, setNewName] = useState("");
  const [onConfirmCallback, setOnConfirmCallback] = useState<(newName: string) => void>(() => () => { });
  const [originalName, setOriginalName] = useState('')
  const openRenameModal = (defaultName: string, onConfirm: (newName: string) => void) => {
    setNewName(defaultName);
    setOriginalName(defaultName);
    setOnConfirmCallback(() => onConfirm);
    setOpen(true);
  };

  const disabled = useMemo(() => !newName.trim() || newName.trim() === originalName, [newName, originalName])

  const handleConfirm = () => {
    if (!newName.trim()) return;
    onConfirmCallback(newName);
    setOpen(false);
  };

  const RenameModal = (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth={"sm"} fullWidth>
      <DialogTitle>Name already exists</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>Please enter a new name</DialogContentText>
        <TextField
          autoFocus
          variant="standard"
          sx={{
            width: '90%',
            color: 'white',
            '& label, label.Mui-focused': {
              color: 'white',
            },
            '& .MuiInput-underline:after': {
              borderBottomColor: '#888', 
            },
          }}
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
        />

      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
        <Button disabled={disabled} onClick={handleConfirm} color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );

  return { newName, openRenameModal, RenameModal };
};

export default useRenameModal;
